module.exports = __webpack_public_path__ + "img/0d18853.jpg";